import {
  Button,
  Flex,
  FormLabel,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

import { z } from 'zod/v4';
import { useGetDeliverableContainerReceiptsQuery } from '~/core/routes/deliverables/[deliverableId]/queries/GetDeliverableContainerReceipts.gql.generated';
import { Icon } from '~/packages/common-frontend/components/icons';

// Types
const ExternalRouteParamsStruct = z.object({
  deliverableId: z.string({ message: 'Missing URL parameter' }),
  receiptId: z.string({ message: 'Missing URL parameter' }),
});

// Exports
export const ReceiptSelector = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { deliverableId, receiptId } = ExternalRouteParamsStruct.parse(params);
  const toast = useToast();

  const receiptsQuery = useGetDeliverableContainerReceiptsQuery({
    variables: { containerId: deliverableId },
  });
  const receipts = receiptsQuery.data?.deliverableContainerReceipts;

  useEffect(() => {
    if (receiptsQuery.error) {
      toast({ title: 'Could not load deliverable receipts' });
    }
  }, [receiptsQuery.error, toast]);

  const currentReceipt = receipts?.find((r) => r.id === receiptId);
  useEffect(() => {
    if (receiptsQuery.data && !currentReceipt) {
      toast({ title: 'Could not find version with this id.' });
      navigate(`/deliverables`);
    }
  }, [currentReceipt, navigate, receiptsQuery.data, toast]);

  if (receiptsQuery.error) return null;

  return (
    <Flex direction="column">
      <FormLabel>Report Version</FormLabel>
      <Menu>
        <MenuButton
          as={Button}
          isLoading={receiptsQuery.loading}
          textAlign="start"
          variant="secondary-muted"
          colorScheme="gray"
          rightIcon={<Icon icon="chevron-down" />}
        >
          Version - {currentReceipt?.version}
        </MenuButton>
        <MenuList width="300px">
          {receipts?.map((receipt) => (
            <MenuItem
              key={receipt.id}
              onClick={() => {
                // don't reload page if they click on the current receipt they are viewing
                if (currentReceipt && receipt.id !== currentReceipt.id) {
                  navigate({
                    pathname: location.pathname.replace(
                      currentReceipt.id,
                      receipt.id,
                    ),
                  });
                }
              }}
            >
              Version - {receipt.version}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Flex>
  );
};
